import { useLocation } from "react-router-dom";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import CreateForm from "components/Form/CreateForm/CreateForm";
import useAPI from "../../../hooks/useAPI";
import ContactPage from "../ContactPage";
import formFields from "./formFields.json";
import { useTranslation } from "react-i18next";
import { printError } from "../../../helpers/apiError";
import scss from "./ContactForm.module.scss";

const ContactForm = () => {
    const { t } = useTranslation();

    const [data, setData] = useState({ title: "", message: "" });
    const [product, setProduct] = useState();
    const api = useAPI();
    const [loading, setLoading] = useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const slug = searchParams.get("slug");

    const { data: basic, ...basicQuery } = useQuery([`Product:${slug}:Basic`, slug], () => api.get(`/product-details/basic-data/${slug}`), {
        enabled: !!slug,
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
    });

    const setDatas = () => {
        if (basicQuery.isSuccess) {
            setProduct(basic.data);
        }
    };
    useEffect(() => {
        setDatas();
    }, [basicQuery.isSuccess]);

    useEffect(() => {
        if (product) {
            setData({
                title: `${t("contact-default-form-field-title-value")} ${product?.item?.basic_data?.name} (${product?.item?.basic_data?.sku})`,
                message: `${t("contact-default-text-dear")}, \n\n ${t("contact-default-form-field-message-value")} ${product?.item?.basic_data?.name} (${product?.item?.basic_data?.sku}). \n\n ${t(
                    "contact-default-text-thank"
                )}`,
            });
        }
    }, [product]);

    return (
        <ContactPage translateKey={"contact-default"}>
            <div className={scss.content}>
                <div>
                    <h4 className={scss.title}>{t("contact-default-title")}</h4>

                    <CreateForm
                        className={scss.form}
                        formButtons={true}
                        loading={loading}
                        data={data}
                        setData={setData}
                        formFields={formFields}
                        submit={{
                            label: "contact-default-form-button-submit",
                            title: "contact-default-form-button-submit",
                            action: () => {
                                if (data.title === "" || data.message === "") {
                                    setLoading(false);
                                } else {
                                    setLoading(true);
                                }
                                if (data.title.trim() === "" || data.message.trim() === "") {
                                    toast.warning(t("contact-default-form-message-enter_data"));
                                    return;
                                }

                                api.post("/contact", data)
                                    .then((response) => {
                                        toast.success(t("contact-default-form-message-success"));
                                        setData({});
                                        setLoading(false);
                                    })
                                    .catch((error) => {
                                        console.error(error);
                                        toast.error(printError(error) ? printError(error) : t("global-message-unknown_error"));
                                        setLoading(false);
                                    });
                            },
                        }}
                    />
                </div>
            </div>
        </ContactPage>
    );
};

export default ContactForm;
